const SubTitle = ({children}) => (
    <h2 className="text-sm pb-2 font-bold tracking-tight text-gray-900 sm:text-lg">{children}</h2>
)

export default SubTitle;